<div class="spinner-wrapper">
  <div class="spinner"></div>
  <p>Redirecting to login...</p>
</div>
